<template>
  <div>
    <small-loading :loading="true" v-if="loading" class="py-2"></small-loading>
    <template v-else>
        <v-input type="v-select" :options="motivosIsencao" v-model="item.ressarcimento.motivoIsencao"
                 v-if="!loading && motivosIsencao.length && motivosIsencaoCompleto.length"
                 :error="validation.motivoIsencao" label="Motivo da Isenção" class="pb-2 col" @change="salvarInformacaoMotivo(item)">
          <div  v-if="item.ressarcimento.anexoObrigatorio" @click="anexarDocumentos(item.id)" style="margin-top: 1%;margin-left: 2%">
            <a title="Anexo" class="icon">
              <i class="fal fa-paperclip"></i>
            </a>
          </div>
        </v-input>

    </template>
  </div>

  </template>

<script >
  import RegrasEstaduaisBusiness from "@/business/RegrasEstaduaisBusiness";
  import SmallLoading from "@/components/SmallLoading.vue";
  import FrontBusiness from "@/business/FrontBusiness";
  import AnexosModal from "@/components/Anexos/AnexosModal.vue";

  export default {
    name: "motivoIsencao",
    components: {SmallLoading},
    props: {
      item: Object,
      validation:{type: Object, default: () => ({})},
    },
    data() {
      return {
        motivosIsencao: [],
        motivosIsencaoCompleto:[],
        loading:false,
      }
    },
    async beforeMount() {
      await this.load();
    },
    methods:{
      async load() {
        this.$set(this, 'loading', true);
        await this.getListarMotivos();
        this.$set(this, 'loading', false);
      },
      async getListarMotivos() {
        this.motivosIsencaoCompleto = await RegrasEstaduaisBusiness.listarMotivoIsencaoBA()
          .catch(error=>{
            FrontBusiness.showError('Motivo de isenção',error)
            return [];
          });
        this.motivosIsencao = (this.motivosIsencaoCompleto)
          .map(m => ({
            id: String(m.id),
            nome: m.motivo,
          }));
      },
      async anexarDocumentos(id) {
        if (this.$root.isEstadoBA) {
          await FrontBusiness.openModal(
            AnexosModal,
            { id, entidade: "COMPROVANTE_ISENCAO", permitirEdicao: true, accept: "application/pdf", extensions: "pdf" }
          );
          return;
        }

        await FrontBusiness.openModal(AnexosModal, {id, entidade: "COMPROVANTE_ISENCAO", permitirEdicao: true});
      },

      salvarInformacaoMotivo(item){
        let motivo = this.motivosIsencaoCompleto.find(m => String(m.id) === item.ressarcimento.motivoIsencao);
        if(motivo){
          item.ressarcimento.anexoObrigatorio = motivo.anexo || false;
        }
      }
    }
  }

</script>


<style scoped lang="scss">

</style>
